import styled from "styled-components";
import bottomBackground from "../../../assets/tingog_signup_bottom_background.png";
import { Button } from "antd";

const NavContainer = styled.nav`
  width: 100%;
  height: 3rem;
  padding: 5px 5px;

  .logo {
    display: flex;
    height: 100%;
    justify-content: flex-end;
  }
`;

const RegisterContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  @media only screen and (min-width: 768px) {
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const RegisterHomePageContainer = styled.div`
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;


  @media only screen and (min-width: 900px) {
    flex-direction: row;
    justify-content: normal;
    background-image: none;
  }

  .mobile-bg {
    width: 100%;
    position: fixed;
    z-index: 1;
    bottom: 0rem;

    @media only screen and (min-width: 320px) {
      bottom: -4rem;
    }

    @media only screen and (min-width: 390px) {
      bottom: 0rem;
    }

    @media only screen and (min-width: 480px) and (orientation: portrait) {
      bottom: -9.5rem;
    }

    @media only screen and (min-width: 768px) {
      bottom: -17.5rem;
    }

    @media only screen and (min-width: 900px) {
      display: none;
    }
  }

  .mobile-gradient {
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 2;

    @media only screen and (min-width: 900px) {
      display: none;
    }
  }

  .left-side-container {
    display: none;

    @media only screen and (min-width: 900px) {
      flex-direction: column;
      position: relative;
      width: 50%;
      display: flex;

      background-image: url(/static/images/register-bg-top-cropped.png);
      background-size: contain;
      background-position: center bottom;
      background-repeat: no-repeat;
    }

    .mr-logo {
      width: 8.5rem;
      margin: 0 30px;
      margin-top: 4rem;
      z-index: 5;

      @media only screen and (min-width: 390px) {
        width: 10rem;
        margin-top: 5.5rem;
      }

      @media only screen and (min-width: 480px) and (orientation: portrait) {
        width: 8.5rem;
        margin-top: 2rem;
        margin-left: 2rem;
      }

      @media only screen and (min-width: 768px) {
        width: 12.5rem;
        margin: 0 30px;
        margin-top: 4rem;
      }
    }

    .bg {
      position: fixed;
      width: 55vw;
      bottom: 0;

      @media only screen and (max-width: 899px) {
        display: none;
      }
    }
  }
  
  .text-container {
    text-align: center;
    z-index: 99;

    @media only screen and (min-width: 768px) {
      width: 55rem;
    }

    @media only screen and (min-width: 900px) {
      width: 100%;
      flex-direction: column;
    }

    h2,
    strong {
      margin-bottom: 18px;
      color: #4D4D4D;
      text-align: center;
      font-size: 21px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;

      @media only screen and (min-width: 320px) {
        line-height: 24px;
        font-size: 20px;
      }

      @media only screen and (min-width: 768px) {
        font-size: 2rem;
        line-height: 2.5rem;
      }
    }

    strong {
      font-weight: 600;
    }
  }
  
  .logo-banner-container {
    .logo-banner {
      display: block;
      width: 272px;
      margin: 40px auto;
    }
    .logo-sm {
      display: block;
      width: 86px;
      margin: 40px auto;
    }
  }

  .right-side-container {
    flex: 1 1 auto;
    margin-top: 5rem;
    z-index: 99;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;

    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    box-shadow: 0px -11px 32px 0px rgba(0, 0, 0, 0.15);
    
    background-color: #FFF;
    background-image: url(/static/images/register-bg-top-cropped.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center bottom;

    @media only screen and (min-width: 768px) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    @media only screen and (min-width: 900px) {
      flex-direction: column;
      justify-content: normal;
      gap: 10rem;
      margin: 0 auto;
      width: 50%;
      border-radius: 0;
      background-image: none;
      background-color: #107400;
      
      .text-container {
        display: none;
      }
    }

    .text-container-desktop {
      margin-top: 30vh;
      display: none;

      @media only screen and (min-width: 900px) {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-left: 40px;
      }

      h2 {
        text-align: left;
        margin-bottom: 18px;
        font-size: 21px;
        font-style: normal;
        line-height: normal;
        color: #FFF;
        
        strong{
          font-weight: 700;
          color: #FFF;
        }

        @media only screen and (min-width: 320px) {
          line-height: 24px;
          font-size: 20px;
        }

        @media only screen and (min-width: 768px) {
          font-size: 2rem;
          line-height: 2.5rem;
        }
      }
    }

    .button-container {
      padding-right: 40px;
      padding-left: 40px;
      width: 100%;

      .mobile-register-btn {
        background-color: #E7B110;
        border: none;
        border-radius: 8px;
        width: 100%;
        height: fit-content;
        padding: 10px 16px;

        span {
          color: #ffffff;

          @media only screen and (min-width: 768px) {
            font-size: 1.35rem;
          }
        }
      }

      .register-btn {
        background-color: transparent;
        border: none;
        display: flex;
        align-items: center;
        gap: 5rem;
        height: auto;
        z-index: 10;

        span {
          color: #ffffff;
          font-size: 2.5rem;
          font-size: 2.2vw;
          font-weight: 600;
          padding: 0;
        }

        .register-btn-arrow {
          width: 3vw;
          height: auto;
        }
      }
      @media only screen and (min-width: 900px) {
        .ant-form-item-label {
          display: none;
          text-align: left;
          margin-left: 20px;
        }
      }
    }

    .gradient {
      width: 45vw;
      position: fixed;
      bottom: -2.5rem;
      z-index: 2;

      @media only screen and (max-width: 899px) {
        display: none;
      }
    }
  }
`;

const RegisterHeader = styled.div`
  width: 100%;
  height: 145px;
  /* background-image: url(/static/images/register-bg-top-2.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center; */
  background-color: #FAFAFA;
  z-index: 1;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media only screen and (min-width: 768px) {
    display: none;
  }
  `;

const StepHeader = styled.div`
  width: 100%;
  height: 140px;
  background-color: #FAFAFA;
  /* background-image: url(/static/images/register-bg-top-2.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center; */
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: 768px) {
    display: none;
  }
`;

const RegisterFooter = styled.div`
  @media only screen and (min-width: 768px) {
    display: block;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5%;
    background-image: url(${bottomBackground});
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 2;
  }
`;

const RegisterHomePageFooter = styled.div`
  display: block;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 5%;
  background-image: url(${bottomBackground});
  background-size: cover;
  background-repeat: no-repeat;
`;

const RegisterFormContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const RegisterLogoContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100%;

  @media only screen and (min-width: 768px) {
    display: none;
  }
`;

const TermsAndConditionLogoContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100%;

  @media only screen and (min-width: 768px) {
    position: initial;
    min-width: 15rem;
    max-width: 20rem;
  }
`;

const RegisterLogo = styled.img`
  width: 60%;
  height: auto;
  align-self: flex-end;
  padding-bottom: 30px;

  @media only screen and (min-width: 768px) {
    width: 8rem;
    margin: 0 auto;
    display: flex;
    margin-top: 5rem;
  }
`;

const UploadImageAvatar = styled.img`
  border-radius: 50%;
  min-height: 130px;
  max-height: 130px;
  object-fit: cover;
  min-width: 130px;
  max-width: 130px;
`;

const UploadButton = styled(Button)``;

const RegisterStepContainer = styled.div`
  overflow-y: scroll;
  margin-top: 10px;
  padding-bottom: 1.5rem;
  height: calc(100vh - 10rem - 3rem - 170px - 10px);
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;

  @media only screen and (min-width: 768px) {
    height: fit-content;
    width: 100%;
    padding: 0;
    overflow-y: auto;
  }
`;

const OtpStepContainer = styled.div`
  overflow-y: scroll;
  margin-top: 10px;
  padding-bottom: 1.5rem;
  height: calc(100vh - 10rem - 3rem - 170px - 10px);
  display: flex;
  flex-direction: column;
  gap:0;
  width: 100%;
  text-align: center;

  @media only screen and (min-width: 768px) {
    height: fit-content;
    width: 100%;
    padding: 0;
    overflow-y: auto;
  }
`;

const UploadImageStepContainer = styled.div`
  overflow-y: scroll;
  margin-top: 10px;
  padding-bottom: 1.5rem;
  height: calc(100vh - 10rem - 3rem - 170px - 10px);
  display: flex;
  flex-direction: column;
  gap:0;
  width: 100%;
  text-align: center;

  @media only screen and (min-width: 768px) {
    height: fit-content;
    width: 100%;
    padding: 0;
    overflow-y: auto;
  }
`;

const DownloadIdStepContainer = styled.div`
  overflow-y: scroll;
  margin-top: 10px;
  padding-bottom: 1.5rem;
  height: auto;
  display: flex;
  flex-direction: column;
  gap:0;
  width: 100%;
  text-align: center;

  @media only screen and (min-width: 768px) {
    height: fit-content;
    width: 100%;
    padding: 0;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    position: relative;
    z-index: 99;

    .text-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .header-text {
        font-size: 14px;
        font-weight: 600;
        text-align: center;

        @media only screen and (min-width: 768px) {
          width: 100%;
          font-size: 2rem;
          font-weight: 600;
        }
      }

      .help-text {
        .help-text-download {
          color: #107400;
          font-weight: 700;
        }

        @media only screen and (max-width: 767px) {
          display: none;
        }
      }
    }

    .id {
      width: 100%;
      @media only screen and (min-width: 768px) {
        max-width: 30rem;
        height: auto;
      }
    }

    .download-id-btn {
      background-color: white;
      color: #107400;
      font-weight: 600;
      border: 2px solid #107400;
      border-radius: 8px;
      padding: 0.5rem 0;
      width: 100%;
      text-align: center;
      cursor: pointer;

      @media only screen and (min-width: 768px) {
        background-color: #107400;
        color: #fff;
        font-weight: 400;
        border-radius: 4px;

        &:disabled {
          background-color: #e0e0e0;
          color: #000000;
          border-color: #e0e0e0;
        }
      }
    }
  }

  .id-card-download {
    .btn-container {
      display: flex;
      justify-content: center;

      @media only screen and (min-width: 768px) {
        display: none;
      }

      .submit-btn {
        span {
          font-weight: 400;
        }
      }
    }
  }

  .register-again-btn {
    width: 100%;
    background-color: #107400;
    color: #fff;
    font-weight: 400;
    border: 2px solid #107400;
    border-radius: 8px;
    padding: 0.5rem 0;
    text-align: center;
    cursor: pointer;
  }
`;

const LastStepContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 80vh;

  a {
    color: #000000;
    text-decoration: underline;
  }

  @media only screen and (min-width: 768px) {
    text-align: center;
  }
`;
const RegisterTermsAndConditionContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .terms-text-container {
    padding: 20px;

    @media only screen and (min-width: 768px) {
      padding: 0;
    }
    @media only screen and (min-width: 900px) {
      padding: 40px;
    }
  }

  @media only screen and (min-width: 768px) {
    display: flex;
  }
`;

const TermsAndConditionButtonContainer = styled.div`
  background-color: #107400;
  position: fixed;
  bottom: 0;
  padding: 0 20px;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 10rem;
  width: 100%;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;

  .checkbox-container {
    display: flex;
    justify-content: center;
    gap: 1rem;

    .agreement-text {
      margin: 0;
      color: #fff;
      width: fit-content;
    }

    .ant-form-item-control-input {
      display: flex;
      align-items: flex-start;
    }
  }

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    height: 10rem;
    padding: 0;
    padding: 0 10rem;
    justify-content: flex-start;

    .checkbox-container {
      align-items: center;
      gap: 1rem;

      .agreement-text {
        margin-right: 2rem;
      }

      .ant-form-item {
        margin: 0;
      }

      .ant-form-item-control-input {
        align-items: center;
      }
    }
  }
`;

const TermsAndConditionTitle = styled.div`
  display: flex;
  color: #107400;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: center;
  margin-bottom: 25px;

  @media only screen and (min-width: 768px) {
    height: 10rem;
    font-size: 2.5vw;
    justify-content: center;
    align-items: center;
  }
`;

const TermsAndConditionContent = styled.div`
  overflow-y: scroll;
  margin-top: 10px;
  padding-bottom: 5rem;
  height: calc(100vh - 10rem - 3rem - 170px);
  display: flex;
  flex-direction: column;
  gap: 1rem;

  p,
  li,
  ol,
  ul {
    text-align: justify;
    margin: 0;
  }

  @media only screen and (min-width: 768px) {
    width: calc(100% - 1rem);
    height: calc(100vh - 20rem);
    padding-right: 2.5rem;

    scrollbar-width: none;
    &::-webkit-scrollbar {
      background: transparent;
      width: 0.35rem;
    }

    &::-webkit-scrollbar-thumb {
      background: lightgrey;
      border-radius: 10px;
    }
  }
`;

export {
  NavContainer,
  RegisterContainer,
  RegisterFormContainer,
  RegisterHeader,
  StepHeader,
  RegisterFooter,
  RegisterHomePageContainer,
  RegisterHomePageFooter,
  RegisterLogo,
  RegisterLogoContainer,
  TermsAndConditionLogoContainer,
  UploadImageAvatar,
  UploadButton,
  RegisterStepContainer,
  OtpStepContainer,
  UploadImageStepContainer,
  DownloadIdStepContainer,
  LastStepContainer,
  TermsAndConditionButtonContainer,
  RegisterTermsAndConditionContainer,
  TermsAndConditionTitle,
  TermsAndConditionContent,
};
